import _ from 'lodash'
import store from '@/store'
import { formatPriceWithoutCurrency } from '@/core/localization'
import utils from '@/core/utils'

/* eslint-disable */

/*
  - search
  + add to cart
  + remove from cart
  + purchase
  + checkout process
  + set checkout step
  + get the currency
  - add events for all
*/

// Helper Functions

function createEventObject(event, data, callback) {
  const eventObject = {
    event,
    ...data
  }

  if (store.getters.clientModel.impersonating || store.getters.clientModel.isSuperUser) {
    eventObject['dimension3'] = 'seller'
  } else {
    eventObject['dimension3'] = 'buyer'
  }

  if (store.getters.clientModel.user && !_.has(data, 'account_type')) {
    eventObject['account_type'] = getAccountType(store.getters.clientModel.user.isCompanyCustomer)
  }

  if (callback) {
    eventObject['eventCallback'] = callback
  }

  return eventObject
}

function addEvent (eventObject) {
  const dataLayer = _.get(window, 'dataLayer')

  dataLayer.push({ ecommerce: null })
  dataLayer.push(eventObject);
}

function createGtmItem(id, name, brand, category, price, quantity, listType) {
  const gtmItem = {
    item_id: id,
    item_name: name,
    price,
    quantity
  }
  if (brand) gtmItem.item_brand = brand
  if (category) gtmItem.item_category = category
  if (listType) gtmItem.item_list_id = listType

  return gtmItem
}

function createGtmItemsFromCart(cart) {
  let value = 0;
  const items = _.map(cart.rows, (row) => {
    const price = parseFloat(formatPriceWithoutCurrency(row.price))
    value += price * row.quantity

    return {
      item_id: row.itemId,
      item_name: row.displayName,
      item_brand: row.item.purchasedToVehicle,
      item_category: row.item.purchasedOnCategory,
      price,
      quantity: row.quantity,
    }
  })

  return { value, items }
}

function addTagEventGeneric(event, category, action, label, value) {
  addEvent({
    'event': event,
    'eventCategory': category,
    'action': action,
    'label': label,
    'value': value
  })
}

// Events

function addToCart(items) {
  const itemList = _.isArray(items) ? items : [items]
  const data = {
    currency: store.getters.clientModel.currency,
    value: itemList.reduce((tot, val) => tot + parseFloat(val.price) * val.quantity, 0),
    items: itemList,
  }

  const chatSessionId = utils.getQueryStringParam('chatSession')
  var aiAssisted = false
  if(chatSessionId){
    const storedSessionId = localStorage.getItem('sessionId')
    aiAssisted = storedSessionId == chatSessionId;
  }

  const eventObject = createEventObject('add_to_cart', { ecommerce: data, ai_assisted: aiAssisted })

  addEvent(eventObject)
}

function removeFromCart(items) {
  const itemList = _.isArray(items) ? items : [items]
  const data = {
    currency: store.getters.clientModel.currency,
    value: itemList.reduce((tot, val) => tot + parseFloat(val.price) * val.quantity, 0),
    items: itemList,
  }
  const eventObject = createEventObject('remove_from_cart', { ecommerce: data })

  addEvent(eventObject)
}

function addCheckoutStep(event, cart, info = {}) {
  const availableEvents = ['begin_checkout', 'add_shipping_info', 'add_payment_info', 'view_cart']
  if (!availableEvents.includes(event)) return

  const { value, items } = createGtmItemsFromCart(cart)

  const data = {
    currency: store.getters.clientModel.currency,
    value,
    items,
    ...info,
  }

  const eventObject = createEventObject(event, { ecommerce: data })
  addEvent(eventObject)
}

function addPurchase(order) {
  let value = 0
  const items = _.map(order.orderRows, (row) => {

    const price = parseFloat(formatPriceWithoutCurrency(row.priceForEachItem))
    value += price * row.quantity

    return {
      item_id: row.artNr,
      item_name: row.artName,
      item_brand: row.brandName,
      affiliation: 'OIE - Web',
      item_category: row.categoryUrl,
      price: price,
      quantity: row.quantity,
    }
  })

  const data = {
    currency: store.getters.clientModel.currency,
    transaction_id: order.orderHead.orderNr,
    value,
    shipping: parseFloat(formatPriceWithoutCurrency(order.orderHead.shipmentCost)),
    tax: parseFloat(formatPriceWithoutCurrency(order.orderHead.vatSum)),
    items
  }

  const eventObject = createEventObject('purchase', { ecommerce: data })

  addEvent(eventObject)
}

function addSignUpEvent(isCompanyCustomer) {
  const eventObject = createEventObject('sign_up', { account_type: getAccountType(isCompanyCustomer) })
  addEvent(eventObject)
}

function addSearchEvent(typeOfSearch, section, query, hits) {
  addTagEventGeneric('Search', section, typeOfSearch, query, hits)
}

function addViewItem(data) {
  const eventObject = createEventObject('view_item', { ecommerce: data })
  addEvent(eventObject)
}

function getAccountType(isCompanyCustomer) {
  return isCompanyCustomer ? 'company' : 'individual'
}

function chatSessionStart(sessionId) {
  addEvent({
    event: 'chatbot_session_start',
    chatbot_session_id: sessionId,
    timestamp: new Date().toISOString()
  })
}

function chatSessionEnd(sessionId, messageCount, endReason) {
  endReason = endReason || 'unknown';
  addEvent({
    event: 'chatbot_session_end',
    chatbot_session_id: sessionId,
    chatbot_total_messages: messageCount,
    chatbot_end_reason: endReason,
    timestamp: new Date().toISOString()
  })
}

function chatProductClick(product, sessionId) {
  addEvent({
    event: 'chatbot_product_click',
    chatbot_session_id: sessionId,
    chatbot_product_name: product.partName,
    chatbot_product_number: product.partNumber,
    timestamp: new Date().toISOString()
  })
}

function chatWebContentClick(url, sessionId) {
  addEvent({
    event: 'chatbot_webcontent_click',
    chatbot_session_id: sessionId,
    chatbot_webcontent_url: url,
    timestamp: new Date().toISOString()
  })
}

export default {
  addSearchEvent,
  addToCart,
  removeFromCart,
  addPurchase,
  createGtmItem,
  addCheckoutStep,
  addSignUpEvent,
  addViewItem,
  chatSessionStart,
  chatSessionEnd,
  chatProductClick,
  chatWebContentClick
}
